module.exports = __webpack_public_path__ + "img/red_bg1.6cadd8a2.png";